import { useInfiniteQuery } from "@tanstack/react-query"
import * as learnPracticeService from "../services/learnPractice.service"
import type { ExploreRitualsFilters } from "../types"

export function useExploreRituals(filters: ExploreRitualsFilters) {
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage, error } =
    useInfiniteQuery({
      queryKey: ["explore-rituals", filters],
      queryFn: ({ pageParam = 1 }) =>
        learnPracticeService.getExploreRituals(pageParam as number, 8, filters),
      initialPageParam: 1,
      getNextPageParam: lastPage => {
        if (lastPage.hasMore) {
          return lastPage.page + 1
        }
        return undefined
      },
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    })

  const rituals = data?.pages.flatMap(page => page.rituals) ?? []
  const total = data?.pages[data.pages.length - 1]?.total ?? 0

  return {
    rituals,
    total,
    isLoading,
    isFetchingNextPage,
    hasNextPage: hasNextPage ?? false,
    fetchNextPage,
    error,
  }
}
